/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ISygmaMessageReceiver,
  ISygmaMessageReceiverInterface,
} from "../ISygmaMessageReceiver";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "message",
        type: "bytes",
      },
    ],
    name: "handleSygmaMessage",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
];

export class ISygmaMessageReceiver__factory {
  static readonly abi = _abi;
  static createInterface(): ISygmaMessageReceiverInterface {
    return new utils.Interface(_abi) as ISygmaMessageReceiverInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISygmaMessageReceiver {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ISygmaMessageReceiver;
  }
}
